import http from '../api';
import * as TYPE from './mutation-type.js';
// import { providerList } from '@/assets/js/constant.js';

export default {
  getUserInfo({ commit }, pos) {
    let addressComponent = {};
    if (pos) {
      addressComponent = pos.addressComponent;
    }

    return http.getBasicInfo().then(data => {
      if (data.districtCode) {
        commit(TYPE.SET_USER_INFO, data);
      } else {
        commit(TYPE.SET_USER_INFO, {
          ...data,
          province: addressComponent.province,
          city: addressComponent.city,
          districtCode: addressComponent.district
        });
      }

      return data;
    });
  },
  getAddressList({ commit }) {
    http.getAddressList().then(data => {
      commit(TYPE.SET_ADD_LIST, data.addressList);
      return data.addressList;
    });
  },

  // fetchProviderItems({ commit }) {
  //   var params = window.util.getUrlParams(location.href);
  //   const rxId = params.rxId;
  //   const ids = params.ids && params.ids.split(',');
  //   const nums = params.nums && params.nums.split(',');

  //   if (!rxId || !Array.isArray(ids) || !ids.length) {
  //     window.alert('参数异常');
  //     return;
  //   }
  //   return http.recepeItems(ids.join(',')).then(data => {
  //     var items = {};
  //     data.forEach((item, index) => {
  //       var providerId = item.item.provider;
  //       item = item.item;
  //       item.count = nums[index];
  //       // 库存小于0，
  //       // 或有限购，并且可购买数量小于1，
  //       // 或已下架
  //       // 或活动商品
  //       // 或库存小于购买数量
  //       // 或可购买数量小于购买数量
  //       if (
  //         item.stock <= 0 ||
  //         (item.buyLimit > 0 && item.buyRemains < 1) ||
  //         item.status == 1 ||
  //         (item.stock > 0 && item.status !== 1 && item.canBuy != undefined && item.canBuy === false) ||
  //         item.stock < item.count ||
  //         (item.buyLimit > 0 && item.buyRemains < item.count)
  //       ) {
  //         providerId = -1;
  //         item.mainImg = '../img/shop_lack.png';
  //       }
  //       if (!items[providerId]) {
  //         items[providerId] = {
  //           providerInfo: providerList[providerId] || {},
  //           items: []
  //         };
  //       }
  //       items[providerId].items.push(item);
  //     });
  //     commit(TYPE.SET_PROVIDER_ITEMS, items);
  //     return items;
  //   });
  // }
  async getRxShadeConfig({ commit }) {
    const { data } = await http.getRxShadeConfig();
    commit(TYPE.SET_RX_SHADE_CONFIG, data);
    console.log('zzzzz', data)
  }
};
